export default __webpack_public_path__ + "static/media/p76.57f69fb8.jpg";